module.exports = __webpack_public_path__ + "static/scale-model-of-douglass-park-in-lexington-kentucky-e7a5ee282cc3da67a0cf1f28dee56452.png";